import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { contentSubmissionRepository } from '../repositories/contentSubmission.repository';
import { contentKeys } from '../services/content.keys';
import type { TopPost } from '../types/content.types';

export const useTopPerformingPosts = (campaignId: string) => {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id || '';

  return useQuery<TopPost[]>({
    queryKey: contentKeys.topPosts(orgId, campaignId),
    queryFn: async (): Promise<TopPost[]> => {
      if (!campaignId || !orgId) return [];
      return contentSubmissionRepository.getTopPerformingPosts(orgId, campaignId);
    },
    enabled: !!campaignId && !!orgId,
    staleTime: 5 * 60 * 1000,
  });
};
